<!-- general templates -->

<!--  Name -->
<ng-template #name>
  <p
    data-cy="non-usf-card-name"
    class="center-p clickable product-name contain"
    (click)="onNameClick()"
  >
    {{ productData?.productDescLong | truncateWithEllipsis: 55 }}
  </p>
</ng-template>

<ng-template #nameTablet>
  <p class="center-p contain product-name">
    <span class="clickable" data-cy="non-usf-card-name" (click)="onNameClick()">
      {{ productData?.productDescLong | truncateWithEllipsis: 40 }}
    </span>
    <br />
    <span *ngIf="productData?.productNumber">
      P#
      {{ productData?.productNumber.toString() | truncateAtStartEllipsis: 7 }}
    </span>
    <span *ngIf="!productData?.productNumber"> N/A </span>
    <img
      data-cy="non-usf-card-separator-image"
      src="assets/images/separator.png"
      class="card-separator-image"
    />
    <span *ngIf="productData?.salesPackSize">
      {{ productData?.salesPackSize | truncateWithEllipsis: 12 }}
    </span>
    <span *ngIf="!productData?.salesPackSize"> N/A </span>
    <img
      *ngIf="productData?.price"
      data-cy="non-usf-card-separator-image"
      src="assets/images/separator.png"
      class="card-separator-image"
    />
    <span *ngIf="productData?.price">
      {{ productData?.price | currency | truncateWithEllipsis: 12 }}
    </span>
    <span *ngIf="!productData?.price"> N/A </span>
  </p>
</ng-template>

<ng-template #nameMobile>
  <p
    class="center-p clickable mobile-name"
    data-cy="non-usf-card-name"
    (click)="onNameClick()"
  >
    {{ productData?.productDescLong | truncateWithEllipsis: 25 }}
  </p>
</ng-template>

<!--  Product number -->
<ng-template #productNumber>
  <p class="center-p" data-cy="non-usf-product-number">
    #{{ productData?.productNumber }}
  </p>
</ng-template>

<ng-template #productMobile>
  <p class="center-p" data-cy="non-usf-product-number">
    P#: {{ productData?.productNumber.toString() | truncateAtStartEllipsis: 7 }}
  </p>
</ng-template>

<!--  Vendor -->
<ng-template #vendor>
  <p class="center-p" data-cy="non-usf-vendor" *ngIf="productData.vendorName">
    {{ productData?.vendorName | truncateWithEllipsis: 12 }}
  </p>
  <p
    class="center-p"
    data-cy="non-usf-vendor-not-found"
    *ngIf="!productData.vendorName"
  >
    N/A
  </p>
</ng-template>

<!--  Brand -->
<ng-template #brand>
  <p class="center-p" data-cy="non-usf-brand" *ngIf="productData.brand">
    {{ productData?.brand | truncateWithEllipsis: 12 }}
  </p>
  <p
    class="center-p"
    data-cy="non-usf-brand-not-found"
    *ngIf="!productData.brand"
  >
    N/A
  </p>
</ng-template>

<!--  Manufacture -->
<ng-template #manufacture>
  <p
    class="center-p"
    data-cy="non-usf-manufacture"
    *ngIf="productData.manufacturerProductNumber"
  >
    #{{ productData?.manufacturerProductNumber | truncateWithEllipsis: 12 }}
  </p>
  <p
    class="center-p"
    data-cy="non-usf-manufacture-not-found"
    *ngIf="!productData.manufacturerProductNumber"
  >
    N/A
  </p>
</ng-template>

<ng-template #manufactureMobile>
  <p class="center-p" *ngIf="productData.manufacturerProductNumber">
    M#:
    {{ productData?.manufacturerProductNumber | truncateWithEllipsis: 12 }}
  </p>
  <p
    class="center-p"
    data-cy="non-usf-manufacture-not-found"
    *ngIf="!productData.manufacturerProductNumber"
  >
    N/A
  </p>
</ng-template>

<!--  Pack Size -->
<ng-template #pack>
  <p class="center-p" data-cy="non-usf-pack" *ngIf="productData.salesPackSize">
    {{ productData?.salesPackSize }}
  </p>
  <p class="center-p" data-cy="non-usf-pack" *ngIf="!productData.salesPackSize">
    N/A
  </p>
</ng-template>

<!--  Price -->
<ng-template #price>
  <p *ngIf="productData?.price" class="center-p" data-cy="non-usf-price">
    {{ productData?.price | currency | truncateWithEllipsis: 12 }}
  </p>
  <p *ngIf="!productData?.price" class="center-p" data-cy="non-usf-no-price">
    N/A
  </p>
</ng-template>

<ng-template #select>
  <ion-row class="drag-and-select">
    <ion-col size="6" (click)="onSelect()">
      <app-usf-checkbox
        data-cy="non-usf-card-checkbox"
        [isSelected]="productData?.isSelected"
      ></app-usf-checkbox>
    </ion-col>
    <ion-col size="6" class="drag-drop">
      <ion-icon
        data-cy="non-usf-card-drag-drop-icon"
        name="menu"
        class="hide"
      ></ion-icon>
    </ion-col>
  </ion-row>
</ng-template>

<!-- main templates -->

<ng-template #desktopMain>
  <ion-col size="0.75">
    <ng-container [ngTemplateOutlet]="select"></ng-container>
  </ion-col>

  <ion-col size="3.45" offset="0.1">
    <ng-container [ngTemplateOutlet]="name"></ng-container>
  </ion-col>

  <ion-col size="1.15" offset="0.1">
    <ng-container [ngTemplateOutlet]="vendor"></ng-container>
  </ion-col>

  <ion-col size="1.15" offset="0.1">
    <ng-container [ngTemplateOutlet]="brand"></ng-container>
  </ion-col>

  <ion-col size="1.15" offset="0.1">
    <ng-container [ngTemplateOutlet]="productNumber"></ng-container>
  </ion-col>

  <ion-col size="1.15" offset="0.1">
    <ng-container [ngTemplateOutlet]="manufacture"></ng-container>
  </ion-col>

  <ion-col size="1.15" offset="0.1">
    <ng-container [ngTemplateOutlet]="pack"></ng-container>
  </ion-col>

  <ion-col size="1.15" offset="0.1">
    <ng-container [ngTemplateOutlet]="price"></ng-container>
  </ion-col>
</ng-template>

<ng-template #tabletMain>
  <ion-col size="1.25">
    <ng-container [ngTemplateOutlet]="select"></ng-container>
  </ion-col>

  <ion-col size="4" offset="0.25">
    <ng-container [ngTemplateOutlet]="nameTablet"></ng-container>
  </ion-col>

  <ion-col size="1.75" offset="0.25">
    <ng-container [ngTemplateOutlet]="vendor"></ng-container>
  </ion-col>

  <ion-col size="1.75" offset="0.25">
    <ng-container [ngTemplateOutlet]="brand"></ng-container>
  </ion-col>

  <ion-col size="1.75" offset="0.25">
    <ng-container [ngTemplateOutlet]="manufacture"></ng-container>
  </ion-col>
</ng-template>

<ng-template #mobileMain>
  <ion-col size="3">
    <ng-container [ngTemplateOutlet]="select"></ng-container>
  </ion-col>

  <ion-col size="8.5" offset="0.5" class="mobile-info">
    <ion-row>
      <ion-col size="12">
        <ng-container [ngTemplateOutlet]="nameMobile"></ng-container>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="5.5">
        <ng-container [ngTemplateOutlet]="vendor"></ng-container>
      </ion-col>

      <ion-col size="5.5" offset="1">
        <ng-container [ngTemplateOutlet]="brand"></ng-container>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="5.5">
        <ng-container [ngTemplateOutlet]="productMobile"></ng-container>
      </ion-col>

      <ion-col size="5.5" offset="1">
        <ng-container [ngTemplateOutlet]="manufactureMobile"></ng-container>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="5.5">
        <ng-container [ngTemplateOutlet]="pack"></ng-container>
      </ion-col>

      <ion-col size="5.5" offset="1">
        <ng-container [ngTemplateOutlet]="price"></ng-container>
      </ion-col>
    </ion-row>
  </ion-col>
</ng-template>

<ion-row
  data-cy="non-usf-product-card"
  class="non-usf-card"
  [class.selected]="productData?.isSelected"
  [ngClass]="
    platform !== PlatformEnum.desktop
      ? platform === PlatformEnum.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <ng-container
    *ngIf="platform === PlatformEnum.desktop"
    [ngTemplateOutlet]="desktopMain"
  ></ng-container>
  <ng-container
    *ngIf="platform === PlatformEnum.tablet"
    [ngTemplateOutlet]="tabletMain"
  ></ng-container>
  <ng-container
    *ngIf="platform === PlatformEnum.mobile"
    [ngTemplateOutlet]="mobileMain"
  ></ng-container>
</ion-row>
